import {
  lesson16Assignment1,
  lesson16Activity2,
  lesson16Assignment3,
  lesson16Assignment4,
  lesson16Activity5
} from './assignments';
import { createChessboard } from '../../utils';
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE } from '../../utils/constants';


let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_16/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    directions: {
      data: '<b>DIRECTIONS:</b> <br/>Enter the correct numbers </br> in the boxes </br> to continue the pattern.',
      timeout: 3000
    },
    audio: { src: 'img/audio/lesson_16/1.mp3', start: true, controls: false },
    activity: {
      assignmentClass: 'assignment-16-1',
      callback: lesson16Assignment1({
        next: 2
      }),
    },
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_16/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    audio: { src: 'img/audio/lesson_16/2.mp3', start: true, controls: false },
    directions: {
      data: '<b> DIRECTIONS </b> </br> Drag the numbers to the buttons to <br/>create a pattern that makes sense in the elevator.',
      timeout: 8000
    },
    chessboard: {
      board: lesson16Activity2({
        piecesArray: ['bK', 'bR', 'bB', 'bP', 'wK', 'wQ', 'wR', 'wP', 'wN'],
        validatePieces: { 'bK': ['e5', 'e6'], 'bR': ['e4', 'c6'], 'bB': ['c6', 'e4'], 'wN': ['c7', 'c5'], 'bP': ['e6', 'c7'], 'wK': ['c5', 'c4'], 'wQ': ['e7'], 'wR': ['c4', 'e3'], 'wP': ['e3', 'e5'] },
        pieceLimit: { bK: 1, bB: 1, bR: 1, bP: 1, wK: 1, wQ: 1, wR: 1, wP: 1, wN: 1 },
        pieceTheme: 'assignment_16_2',
        next: 4,
        assignmentClass: 'assignment-16-2',
        resultFen: ['8/2p1Q3/2r1k3/2N1P3/2K1b3/4R3/8/8', '8/2N1Q3/2b1p3/2K1k3/2R1r3/4P3/8/8'],
        repeatActivity: 3
      })
    }
  },
  {
    id: 4,
    previous: 2,
    next: 8,
    video: {
      src: 'img/videos/lesson_16/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5
    }
  },
  {
    id: 5,
    previous: 4,
    next: 8,
    audio: { src: 'img/audio/lesson_16/3.mp3', start: true, controls: false },
    directions: {
      data: '<b> DIRECTIONS: </b> <br/>Find one pattern in this diagram. ',
      timeout: 100
    },
    chessboard: {
      board: lesson16Assignment3({
        showIndicators: { allSides: true },
        coordinatesGreen: ['.square-a6', '.square-b7', '.square-c7', '.square-d6'],
        position: '1k1rr3/1pp1qpp1/p1npbb1p/8/6P1/1PP1BN1P/PKPQRPB1/3R4',
        reminder: true,
        next: 6
      })
    }
  },
  {
    id: 6,
    previous: 4,
    next: 8,
    directions: {
      data: '<b> DIRECTIONS: </b> <br/>Find two patterns in this diagram. ',
      timeout: 100,
      position: 'left',
    },
    chessboard: {
      board: lesson16Assignment3({
        idCommon: false,
        showIndicators: { allSides: true },
        coordinatesGreen: ['.square-f7', '.square-g7', '.square-h7', '.square-g6'],
        coordinateNonePointerGreen: ['.square-f7', '.square-g7', '.square-h7', '.square-g6'],
        coordinatesYellow: ['.square-d5', '.square-e4', '.square-f3', '.square-g2'],
        coordinateNonePointerYellow: ['square-d5', '.square-e4', '.square-f3', '.square-g2'],
        position: 'r1brq1k/1pp1ppbp/pn4p1/n2P4/4P3/2N1BP2/PP4PP/1KQR1BNR',
        reminder: true,
        next: 7
      })
    }
  },
  {
    id: 7,
    previous: 4,
    next: 8,
    directions: {
      data: '<b> DIRECTIONS: </b> <br/>Find three patterns in this diagram. ',
      timeout: 100,
      position: 'left',
    },
    chessboard: {
      board: lesson16Assignment3({
        idCommon: true,
        showIndicators: { allSides: true },
        coordinatesGreen: ['.square-d4', '.square-e3', '.square-f2'],
        coordinateNonePointerGreen: ['.square-d4', '.square-e3', '.square-f2'],
        coordinatesYellow: ['.square-e6', '.square-f7', '.square-g7', '.square-h6'],
        coordinateNonePointerYellow: ['.square-h6', '.square-g7'],
        coordinatesPurple: ['.square-d5', '.square-e6', '.square-f7'],
        coordinateNonePointerPurple: ['.square-d5'],
        position: 'rnbq1rk1/p1p1bpp1/1p2pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R',
        reminder: true,
        next: null
      })
    }
  },
  {
    id: 8,
    previous: 4,
    next: 14,
    video: {
      src: 'img/videos/lesson_16/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 9
    }
  },

  {
    id: 9,
    previous: 8,
    next: 14,
    audio: { src: 'img/audio/lesson_16/4.mp3', start: true, controls: false },
    directions: {
      timeout: 4000,
      data: '<b>DIRECTIONS:</b> <br/>Find a zig zag path <br/>for White to checkmate Black in 3 moves.'
    },
    chessboard: {
      board: lesson16Assignment4({
        position: 'k4b2/p1B4n/P2p1p2/3Pp1pp/1p2P3/1P3P2/2B3PP/1K6',
        resultFen: 'k2b4/p1B4n/P1Bp1p2/3Pp1pp/1p2P3/1P3P2/6PP/1K6',
        next: 10,
        moves: {
          studentMove: {
              from: ['c2', 'd3', 'b5'],
              to: ['d3', 'b5', 'c6']
          },
          computerMove: {
              from: ['f8', 'e7'],
              to: ['e7', 'd8']
          }
      },
        showIndicators: { allSides: true },
        MagnusText: `nice job`,
        restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
        initialMoveOf: WHITE_INITIAL_MOVE,
        fromArrow: 'square-c6',
        toArrow: 'square-a8',
        offset: [ 5, 5, 5, 4],
      }),
      positionFen: 'k4b2/p1B4n/P2p1p2/3Pp1pp/1p2P3/1P3P2/2B3PP/1K6 w - - 0 1',
      canvas: true
    },
  },
  {
    id: 10,
    previous: 8,
    next: 11,
    video: {
      src: 'img/videos/lesson_16/5.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 11
    }
  },
  {
    id: 11,
    previous: 10,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'Where can you find patterns?',
      answer: [
        'In numbers',
        'In nature',
        'On the chessboard',
        'All of the above'
      ],
      rightAnswer: 'All of the above',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 10,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'What is the purpose of this pattern?',
      answer: [
        'It helps protect the King',
        'The pawns protect each other',
        'The pawns protect the Bishop',
        'It gets you checkmate'
      ],
      chessboard: {
        board: lesson16Activity5({
          showIndicators: true,
          position: 'r1brq1k1/1pp2pbp/pn4p1/n2P4/4PP2/2N1B3/PP4PP/1KQR1BNR',
          highlightSquares: ['.square-f7', '.square-g7', '.square-h7', '.square-g6']
        }),
        hint: true,
      },
      rightAnswer: 'It helps protect the King',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 10,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'What is the purpose of this pattern?',
      answer: [
        'It helps protect the King',
        'The pawns protect each other',
        'It builds a wall',
        'It gets you checkmate'
      ],
      chessboard: {
        board: lesson16Activity5({
          showIndicators: true,
          position: '6k1/p2p3p/8/1p2P3/3P4/2P5/1P5P/6K1',
          highlightSquares: ['.square-b2', '.square-c3', '.square-d4', '.square-e5']
        }),
        hint: true,
      },
      rightAnswer: 'The pawns protect each other',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 14,
    previous: 10,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'What is the purpose of this pattern?',
      answer: [
        'It helps protect the King',
        'The pawns protect each other',
        'It builds a wall',
        'It gets you checkmate'
      ],
      chessboard: {
        board: lesson16Activity5({
          showIndicators: true,
          position: '1k1rr3/1pp1kpp1/p1npbb1p/8/6P1/1PP1BN1P/PKPQRPB1/3R4',
          highlightSquares: ['.square-a6', '.square-b7', '.square-c7', '.square-d6']
        }),
        hint: true,
      },
      rightAnswer: 'It helps protect the King',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 10,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'How many patterns can you count in this diagram?',
      answer: [
        '1',
        '2',
        '3',
        '4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'rn1q1rk1/pb1pbpp1/1p2pn1p/2p5/2P5/2NP1NP1/PP1BPPBP/R2Q1RK1'
        }),
        hint: true,
      },
      rightAnswer: '4',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xs'
    }
  },
  {
    id: 16,
    previous: 10,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'White has a familiar pattern. What one move <br/> can White make to create a different pattern?',
      answer: [
        'b2-b4',
        'g3-g4',
        'Bg2-e4',
        'h2-h4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/2p5/1b4pk/1p5p/8/6P1/1P3PBP/6K1'
        }),
        hint: true,
      },
      rightAnswer: 'h2-h4',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xs'
    }
  },
  {
    id: 17,
    previous: 10,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Both Black and White have a familiar pattern.<br/> With White to move, which pattern is safer?',
      answer: [
        'White is much safer',
        'They are equally safe',
        'Black is a little safer',
        'It doesn’t matter because Black is ahead in points'
      ],
      chessboard: {
        board: lesson16Activity5({
          showIndicators: true,
          position: 'r7/5pp1/4pBkp/4P2n/8/p5P1/5PBP/6K1',
          highlightSquares: ['.square-e6', '.square-f7', '.square-g7', '.square-h6', '.square-f2', '.square-g3', '.square-h2']
        }),
        hint: true,
      },
      rightAnswer: 'White is much safer',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 18,
    previous: 10,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'What is the best move for White?',
      answer: [
        'Bg2xa8',
        'Bf6-e7',
        'Bg2-e4',
        'f2-f4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'r7/5pp1/4pBkp/4P2n/8/p5P1/5PBP/6K1',
        }),
        hint: true,
      },
      rightAnswer: 'Bg2-e4',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 19,
    previous: 10,
    next: 20,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'Black has an excellent pattern of defense,<br/> only one square is unprotected. Which <br/>square is unprotected?',
      answer: [
        'h8',
        'h5',
        'e5',
        'a4'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'rn1q1rk1/1bp1bpp1/pp2pn1p/3p4/8/8/8/8',
        }),
        hint: true,
      },
      rightAnswer: 'e5',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 20,
    previous: 10,
    next: 21,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'What move can White make to create a pattern? ',
      answer: [
        'Castle',
        'd2-d3',
        'd2-d4',
        'Nb1-c3'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R',
        }),
        hint: true,
      },
      rightAnswer: 'd2-d3',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 21,
    previous: 10,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      nextLesson: 'Lesson 17',
      result: true,
      styleClass: 'xl',
      timeout: 7000
    }
  },

]
let assets = [
  '/img/background_6.png',
  '/img/box.png',
  '/img/numbers/assignment_16_2/one.png',
  '/img/numbers/assignment_16_2/two.png',
  '/img/numbers/assignment_16_2/thress.png',
  '/img/numbers/assignment_16_2/four.png',
  '/img/numbers/assignment_16_2/five.png',
  '/img/numbers/assignment_16_2/six.png'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_16/index.js